/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-autofocus */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ThreeDots } from 'react-loader-spinner';
import Button from '../Button/Button';
import { 
  getFolderPath, getDataPath, filterItemsByExclude,
  getAllfoldersDataObjects, getAllDataObjects, isSafari,
  getFoldersDataInFolder, getDataInFolder
 } from '../../helpers/utils';
import { 
  getEndpointFolderTreeRequest,
  removeEndpointsListRequest,
  removeEndpointFolderSuccess, 
  removeEndpointsListSuccess
} from '../../store/endpoints/actions';

import * as styles from './RemoveEndpointsModal.module.scss';

function RemoveEndpointsModal({
  onClose,
  onSubmit,
  model,
  collection,
}) {
  const dispatch = useDispatch();
  const { endpoints = [], folders = [] } = model || {};
  const [filteredFolders, setFilteredFolders] = useState([]);
  const [filteredEndpoints, setFilteredEndpoints] = useState([]);
  const [nestedFolders, setNestedFolders] = useState([]);
  const [nestedEndpoints, setNestedEndpoints] = useState([]);

  const [loadDetails, setLoadDetails] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const calcPaths = () => {
      const f = folders.map((el) => ({ id: el, path: getFolderPath(collection, el) }));
      const e = endpoints.map((el) => ({ id: el, path: getDataPath(collection, el) }));

      const fltF = filterItemsByExclude(f, folders) || [];
      const fltE = filterItemsByExclude(e, folders) || [];

      setFilteredFolders(fltF.map((el) => el.id));
      setFilteredEndpoints(fltE.map((el) => el.id));
    };

    calcPaths();
  }, [model, collection, folders, endpoints]);

  useEffect(() => {
    setLoadDetails(true);

    const fetchData = () => {
      if (!filteredFolders.length) {
        setLoadDetails(false);
        setNestedEndpoints([]);
        setNestedFolders([]);
      } else {
        dispatch(getEndpointFolderTreeRequest({ ids: filteredFolders }, (result) => {
          setLoadDetails(false);
          if (result) {
            const f = result.filter((el) => el.folders).map((el) => el.folders).flat() || [];
            const c = result.filter((el) => el.endpoints).map((el) => el.endpoints).flat() || [];
            setNestedEndpoints(c);
            setNestedFolders(f);
          } else {
            setNestedEndpoints([]);
            setNestedFolders([]);
          }
        }));
      }
    };

    fetchData();
  }, [filteredFolders, dispatch]);

  const sendDeleteRequest = (data) => {
    const { folders: fld = [], endpoints: endp = [] } = data || {};
    const allFolders = getAllfoldersDataObjects(collection);
    const allEndpoints = getAllDataObjects(collection);

    let transformedFolders = [];
    let transformedEndpoints = [];

    if (fld?.length) {
      transformedFolders = fld.map(f => allFolders.find(a => a.id === f)).filter(el => el);
    }

    if (endp?.length) {
      transformedEndpoints = endp.map(f => allEndpoints.find(a => a.id === f)).filter(el => el);
    }

    const excludedFolders = folders.filter(f => !fld.includes(f));
    const excludedEndpoints = endpoints.filter(e => !endp.includes(e));

    if (transformedFolders?.length || transformedEndpoints?.length) {
      setSubmitting(true);
      dispatch(removeEndpointsListRequest({ 
       endpoints: transformedEndpoints,
       folders: transformedFolders
      }, (result) => {
        const { successFolders, successEndpoints } = result || {};
        if (result && (successFolders?.length || successEndpoints?.length)) {
          if (successFolders?.length) {
            successFolders.forEach((f) => {
              const nestedFolders = getFoldersDataInFolder(collection, f.id);
              const nestedData = getDataInFolder(collection, f.id);
  
              excludedFolders?.forEach(f => {
                if (nestedFolders.includes(f)) dispatch(removeEndpointFolderSuccess({ id: f }));
              });
              excludedEndpoints?.forEach(c => {
                if (nestedData.includes(c)) dispatch(removeEndpointsListSuccess({ id: c }));
              });
            });
          }
          setSubmitting(false);
          onSubmit();
        } else {
          setSubmitting(false);
        }
      }));
    }
  };

  const numFilteredFolders = nestedFolders.length || filteredFolders.length;
  const numFilteredEndpoints = filteredEndpoints.length + nestedEndpoints.length;

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <div className={styles.header}>
          <div className={styles.title}>Delete Items</div>
        </div>
        <div className={styles.body}>
          <div className={styles.mainContent}>
            <div>
              <div>
              {loadDetails && !isSafari() && (
                  <span className={styles.modelTitle}
                  style={{ marginRight: '12px' }}
                  >
                  <ThreeDots
                    height="13"
                    width="13"
                    color="#4149F7"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{
                      display: 'inline',
                      transform: 'translateY(-20px)'
                    }}
                    visible
                  />
                  </span>
                )}
                {(numFilteredFolders && !loadDetails) ? (
                  <span className={styles.modelTitle}>
                    {numFilteredFolders}
                    {' '}
                    {numFilteredFolders > 1 ? 'Folders' : 'Folder'}
                  </span>
                ) : null}

                {(numFilteredEndpoints && numFilteredFolders && !loadDetails) ? ', ' : null}

                {(numFilteredEndpoints && !loadDetails) ? (
                  <span className={styles.modelTitle}>
                    {numFilteredEndpoints}
                    {' '}
                    {numFilteredEndpoints > 1 ? 'Endpoints' : 'Endpoint'}
                  </span>
                ) : null}
                {' '}
                will be deleted. Are you sure?
              </div>
            </div>
          </div>
          <div className={styles.buttonGroup}>
              <Button style={{ width: 85 }} title="Cancel" type="secondary" onClick={onClose} />
              <Button
                style={{ width: 120, marginLeft: 12 }}
                type="red"
                title="Delete"
                disabled={submitting}
                onClick={() => {
                  sendDeleteRequest({ folders: filteredFolders, endpoints: filteredEndpoints });
                }}
              />
          </div>
        </div>
      </div>
    </div>
  );
}

export default RemoveEndpointsModal;
